export var CpaRole;
(function (CpaRole) {
    CpaRole["WORKORDER"] = "WORKORDER";
    CpaRole["SPECIALS"] = "SPECIALS";
    CpaRole["ALL"] = "ALL";
    CpaRole["NONE"] = "NONE";
})(CpaRole || (CpaRole = {}));
